import React from 'react'
import { Button } from '@mui/material'
function LoginFooter() {
  return (
    <div>
    <nav class="navbar navbar-expand-lg navbar-light">
  <div class="container-fluid">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="#Link">Privacy Policy</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" href="#Link">Terms of Use</a>
        </li>
      </ul>
      <form class="d-flex">
      <Button variant="outlined" style={{borderRadius:"20px", color:"black", borderColor:"black"}}>Support</Button>
      </form>
    </div>
  </div>
</nav>
    </div>
  )
}

export default LoginFooter
